import type { ReactNode } from 'react';
import React, { Fragment } from 'react';

/**
 * Places styled nodes inside a translated sentence. `tq` only returns strings, so a sentence
 * that needs a styled span in the middle is translated with a sentinel per slot and the nodes
 * are set into the result afterwards — in whatever order the locale puts them. A translation
 * that drops a slot renders the rest of the sentence rather than nothing; one that repeats a
 * slot gets the node repeated.
 *
 * Same idea as `withEmphasizedDate` in PhotosV2 and the sender slot in `SmsBubbleComposer`, for
 * more than one slot.
 */
export const fillSlots = (sentence: string, slots: Readonly<Record<string, ReactNode>>): ReactNode => {
  const names = Object.keys(slots);
  if (names.length === 0) return sentence;
  const pattern = new RegExp(`(${names.map(name => name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`);
  return (
    <>
      {sentence.split(pattern).map((segment, index) => (
        <Fragment key={index}>{segment in slots ? slots[segment] : segment}</Fragment>
      ))}
    </>
  );
};
